import { h } from "../../core/dom.js";
import { historySheet } from "../components/historySheet.js";

const PERIODS = [
  { id: "all", label: "Sempre", days: null },
  { id: "today", label: "Oggi", days: 0 },
  { id: "week", label: "7 giorni", days: 7 },
  { id: "month", label: "30 giorni", days: 30 }
];

export function withinPeriod(createdAt, periodId, now = Date.now()) {
  const period = PERIODS.find((item) => item.id === periodId) || PERIODS[0];
  if (period.days === null) return true;
  if (period.days === 0) return new Date(createdAt).toDateString() === new Date(now).toDateString();
  return createdAt >= now - period.days * 24 * 60 * 60 * 1000;
}

export function filterItems(items, { emotion = "all", period = "all" } = {}, now = Date.now()) {
  return items.filter((item) => (emotion === "all" || item.label === emotion) && withinPeriod(item.createdAt, period, now));
}

export function rankingOf(item, lookup) {
  return Object.entries(item.probabilities || {})
    .map(([id, probability]) => ({ id, probability, ...(lookup[id] || {}) }))
    .sort((a, b) => b.probability - a.probability);
}

export function historyView(app) {
  const list = h("ul", { class: "history" });
  const empty = h("p", { class: "muted center" }, "Nessuna analisi ancora. Inquadra il tuo cane per iniziare!");
  const noMatch = h("p", { class: "muted center hidden" }, "Nessuna analisi con questi filtri.");
  const classes = () => Object.fromEntries((app.classifier.metadata?.classes || []).map((c) => [c.id, c]));
  const format = new Intl.DateTimeFormat("it-IT", { dateStyle: "medium", timeStyle: "short" });
  const filters = { emotion: "all", period: "all" };
  let items = [];

  const emotionSelect = h("select", { class: "filter", "aria-label": "Filtra per emozione",
    onchange: (event) => { filters.emotion = event.target.value; draw(); } });
  const periodSelect = h("select", { class: "filter", "aria-label": "Filtra per periodo",
    onchange: (event) => { filters.period = event.target.value; draw(); } },
    PERIODS.map((period) => h("option", { value: period.id }, period.label)));

  const row = (item) => {
    const lookup = classes();
    const spec = lookup[item.label] || { emoji: item.emoji || "🐾", label_it: item.label_it || item.label };
    const ranking = rankingOf(item, lookup);
    const body = h("div", { class: "history-body" },
      h("strong", {}, `${spec.emoji} ${spec.label_it}${item.uncertain ? " (incerto)" : ""}`),
      h("span", { class: "muted" }, `${Math.round(item.confidence * 100)}% · ${format.format(item.createdAt)}`));
    const open = h("button", { class: "history-open", type: "button" }, body);
    open.addEventListener("click", () => historySheet(app, { item, spec, ranking, onDeleted: load }));
    return h("li", { class: "history-item" },
      item.thumbnail ? h("img", { src: item.thumbnail, alt: "" }) : h("div", { class: "thumb-empty" }, "🐾"),
      h("div", { class: "history-main" }, open),
      h("span", { class: "history-chevron" }, "›"));
  };

  const draw = () => {
    const visible = filterItems(items, filters);
    list.replaceChildren(...visible.map(row));
    empty.classList.toggle("hidden", items.length > 0);
    noMatch.classList.toggle("hidden", items.length === 0 || visible.length > 0);
    clearButton.classList.toggle("hidden", items.length === 0);
    filterRow.classList.toggle("hidden", items.length === 0);
  };

  const load = async () => {
    try {
      items = await app.history.list();
    } catch (error) {
      app.reporter.report(error, "history-list");
      items = [];
    }
    const lookup = classes();
    const present = [...new Set(items.map((item) => item.label))];
    emotionSelect.replaceChildren(
      h("option", { value: "all" }, "Tutte le emozioni"),
      ...present.map((id) => h("option", { value: id }, `${(lookup[id] || {}).emoji || ""} ${(lookup[id] || {}).label_it || id}`)));
    emotionSelect.value = present.includes(filters.emotion) ? filters.emotion : "all";
    filters.emotion = emotionSelect.value;
    periodSelect.value = filters.period;
    draw();
  };

  const clearButton = h("button", { class: "btn btn-ghost wide", type: "button" }, "Svuota lo storico");
  clearButton.addEventListener("click", () => {
    clearButton.replaceChildren();
    clearButton.append(h("span", {}, "Cancellare tutto lo storico? "),
      h("span", { class: "link", onclick: async () => { await app.history.clear(); clearButton.textContent = "Svuota lo storico"; await load(); } }, "Sì"),
      h("span", {}, " · "),
      h("span", { class: "link", onclick: () => { clearButton.textContent = "Svuota lo storico"; } }, "No"));
  });
  const filterRow = h("div", { class: "filters hidden" }, emotionSelect, periodSelect);
  const element = h("section", { class: "view" },
    h("h1", {}, "Storico"),
    h("p", { class: "muted" }, "Le analisi restano solo su questo dispositivo. Tocca una voce per aprirne i dettagli."),
    filterRow, empty, noMatch, list, clearButton);
  return { element, mount: load };
}

